<template>
	<div class="loading">
		<span class="loader"></span>
	</div>
</template>
<script>
	export default {
		name: 'loading',
		data() {
			return {

			}
		},
		methods: {
		}
	}
</script>

<style>
	.loading {
		width: 100%;
		display: flex;
		justify-content: center;
		text-align: center;
		margin-top: 13px;
		margin-bottom: 13px;
	}
	.loader {
		width: 48px;
		height: 48px;
		border: 5px solid #1aa348;
		border-radius: 50%;
		display: inline-block;
		box-sizing: border-box;
		position: relative;
		animation: pulse 1s linear infinite;
		}
		.loader {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  border: 3px solid;
  border-color: #353690 #353690 transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}
.loader::after {
  content: '';  
  box-sizing: border-box;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  border: 3px solid;
  border-color: transparent #1aa348 #1aa348;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  animation: rotationBack 0.5s linear infinite;
  transform-origin: center center;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
} 
    
@keyframes rotationBack {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
    
   
</style>



<!-- <template>
	<div class="loading">
		<div class="lds-ripple">
			<div></div>
			<div></div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'loading',
		data() {
			return {

			}
		},
		methods: {
		}
	}
</script>

<style>
	.loading {
		width: 100%;
		text-align: center;
		margin-top: 13px;
	}
	.lds-ripple {
		display: inline-block;
		position: relative;
		width: 80px;
		height: 80px;
	}

	.lds-ripple div {
		position: absolute;
		border: 4px solid #67C285;
		opacity: 1;
		border-radius: 50%;
		animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
	}

	.lds-ripple div:nth-child(2) {
		animation-delay: -0.5s;
	}

	@keyframes lds-ripple {
		0% {
			top: 36px;
			left: 36px;
			width: 0;
			height: 0;
			opacity: 1;
		}

		100% {
			top: 0px;
			left: 0px;
			width: 72px;
			height: 72px;
			opacity: 0;
		}
	}
</style> -->



// WEBPACK FOOTER //
// src/components/Loading.vue